import Home from '@/components/frame/Home'

const home = {
  isShow: false,
  index: 3,
  path: '/standardization',
  component: Home,
  redirect: '/standardization/standardization/index',
  name: 'standardization',
  isHead: true,
  meta: {
    title: '标准化建设',
    icon: 'el-icon-s-marketing'
  },
  children: [
    {
      path: 'standardization',
      component: () => import('@/views/selfEvaluation/index'),
      name: 'standardization',
      meta: { title: '标准化建设', close: false },
      children: [{
        path: 'index',
        component: () => import('@/views/standardization/index'),
        name: 'Standardization',
        meta: { title: '标准化创建', next: '/standardization/standardization/selfSetting', close: false }
      }, {
        path: 'selfSetting',
        name: 'selfSetting',
        component: () => import('@/views/selfEvaluation/setting/index'),
        meta: {title: '自评表维护', close: false}
      }]
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/standardization.js